// extracted by mini-css-extract-plugin
export default {"dropDownButton":"Menu_dropDownButton__N367J","dropdownMenu":"Menu_dropdownMenu__m1d6N","dropdownItem":"Menu_dropdownItem__2KmSG","textBoon":"Menu_textBoon__1tD+R"};